var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19C15 20.66 13.66 22 12 22C10.34 22 9 20.66 9 19V13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13V19ZM12 24C14.76 24 17 21.76 17 19H19C19 22.53 16.39 25.43 13 25.92V29H11V25.92C7.61 25.43 5 22.53 5 19H7C7 21.76 9.24 24 12 24Z",
    fill: "#5D5E76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 1.16675C18.78 1.16675 16.1666 3.78008 16.1666 7.00008C16.1666 10.2201 18.78 12.8334 22 12.8334C25.22 12.8334 27.8333 10.2201 27.8333 7.00008C27.8333 3.78008 25.22 1.16675 22 1.16675ZM22 7.58341C21.6791 7.58341 21.4166 7.32091 21.4166 7.00008V4.66675C21.4166 4.34591 21.6791 4.08341 22 4.08341C22.3208 4.08341 22.5833 4.34591 22.5833 4.66675V7.00008C22.5833 7.32091 22.3208 7.58341 22 7.58341ZM22.5833 9.91675H21.4166V8.75008H22.5833V9.91675Z",
    fill: "#DEDFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicEnabled);
export default __webpack_public_path__ + "static/media/mic_enabled.c7f6cfe002e748c3ec4b0d5736ab5b88.svg";
export { ForwardRef as ReactComponent };